import PaymentDetails from "components/Policy/AnnuityDetail/PaymentDetails/PaymentDetails";

export default PaymentDetails;
